import React from 'react';
import PropTypes from 'prop-types';

/**
 * Label Atom - komponenty etykiet dla formularzy
 */
const Label = ({ 
  children,
  htmlFor,
  required = false,
  size = 'md',
  weight = 'medium',
  className = '',
  ...props 
}) => {
  const sizeClasses = {
    sm: 'text-sm',
    md: 'text-base',
    lg: 'text-lg'
  };

  const weightClasses = {
    normal: 'font-normal',
    medium: 'font-medium',
    semibold: 'font-semibold'
  };

  const baseClasses = 'text-gray-700';
  
  const classes = [
    baseClasses,
    sizeClasses[size],
    weightClasses[weight],
    className
  ].filter(Boolean).join(' ');

  return (
    <label 
      htmlFor={htmlFor}
      className={classes}
      {...props}
    >
      {children}
      {required && (
        <span className="text-red-500 ml-1" aria-label="required">
          *
        </span>
      )}
    </label>
  );
};

Label.propTypes = {
  children: PropTypes.node.isRequired,
  htmlFor: PropTypes.string,
  required: PropTypes.bool,
  size: PropTypes.oneOf(['sm', 'md', 'lg']),
  weight: PropTypes.oneOf(['normal', 'medium', 'semibold']),
  className: PropTypes.string,
};

export default Label;
